import type { Sku } from "../types";

/**
 * Anthropic, called directly. Inference kept in the US costs a tenth more, and fast mode twice as much.
 */
export const anthropicSkus: readonly Sku[] = [
  {
    id: "anthropic:claude-opus-5-5:global:standard",
    billedBy: "anthropic",
    model: "claude-opus-5-5",
    endpoint: "global",
    tier: "standard",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 4,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.2,
      },
      { id: "cacheWrite5m", meter: "cacheWrite5m", unit: "1M tokens", currency: "USD", amount: 5 },
      { id: "cacheWrite1h", meter: "cacheWrite1h", unit: "1M tokens", currency: "USD", amount: 8 },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 20 },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
      {
        id: "tool:web_fetch",
        meter: "tool:web_fetch",
        unit: "1k uses",
        currency: "USD",
        amount: 0,
      },
    ],
  },
  {
    id: "anthropic:claude-opus-5-5:global:fast",
    billedBy: "anthropic",
    model: "claude-opus-5-5",
    endpoint: "global",
    tier: "fast",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 8,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.4,
      },
      { id: "cacheWrite5m", meter: "cacheWrite5m", unit: "1M tokens", currency: "USD", amount: 10 },
      { id: "cacheWrite1h", meter: "cacheWrite1h", unit: "1M tokens", currency: "USD", amount: 16 },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 40 },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
      {
        id: "tool:web_fetch",
        meter: "tool:web_fetch",
        unit: "1k uses",
        currency: "USD",
        amount: 0,
      },
    ],
  },
  {
    id: "anthropic:claude-opus-5-5:us:standard",
    billedBy: "anthropic",
    model: "claude-opus-5-5",
    endpoint: "us",
    tier: "standard",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 4.4,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.22,
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 5.5,
      },
      {
        id: "cacheWrite1h",
        meter: "cacheWrite1h",
        unit: "1M tokens",
        currency: "USD",
        amount: 8.8,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 22 },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
      {
        id: "tool:web_fetch",
        meter: "tool:web_fetch",
        unit: "1k uses",
        currency: "USD",
        amount: 0,
      },
    ],
  },
  {
    id: "anthropic:claude-opus-5-5:us:fast",
    billedBy: "anthropic",
    model: "claude-opus-5-5",
    endpoint: "us",
    tier: "fast",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 8.8,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.44,
      },
      { id: "cacheWrite5m", meter: "cacheWrite5m", unit: "1M tokens", currency: "USD", amount: 11 },
      {
        id: "cacheWrite1h",
        meter: "cacheWrite1h",
        unit: "1M tokens",
        currency: "USD",
        amount: 17.6,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 44 },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
      {
        id: "tool:web_fetch",
        meter: "tool:web_fetch",
        unit: "1k uses",
        currency: "USD",
        amount: 0,
      },
    ],
  },
  {
    id: "anthropic:claude-sonnet-5-5:global:standard",
    billedBy: "anthropic",
    model: "claude-sonnet-5-5",
    endpoint: "global",
    tier: "standard",
    promptTokensCount: "allInput",
    maxOutputTokens: 64_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 2,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.2,
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.5,
      },
      { id: "cacheWrite1h", meter: "cacheWrite1h", unit: "1M tokens", currency: "USD", amount: 4 },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 10 },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
      {
        id: "tool:web_fetch",
        meter: "tool:web_fetch",
        unit: "1k uses",
        currency: "USD",
        amount: 0,
      },
    ],
  },
  {
    id: "anthropic:claude-sonnet-5-5:global:fast",
    billedBy: "anthropic",
    model: "claude-sonnet-5-5",
    endpoint: "global",
    tier: "fast",
    promptTokensCount: "allInput",
    maxOutputTokens: 64_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 4,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.4,
      },
      { id: "cacheWrite5m", meter: "cacheWrite5m", unit: "1M tokens", currency: "USD", amount: 5 },
      { id: "cacheWrite1h", meter: "cacheWrite1h", unit: "1M tokens", currency: "USD", amount: 8 },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 20 },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
      {
        id: "tool:web_fetch",
        meter: "tool:web_fetch",
        unit: "1k uses",
        currency: "USD",
        amount: 0,
      },
    ],
  },
  {
    id: "anthropic:claude-sonnet-5-5:us:standard",
    billedBy: "anthropic",
    model: "claude-sonnet-5-5",
    endpoint: "us",
    tier: "standard",
    promptTokensCount: "allInput",
    maxOutputTokens: 64_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.2,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.22,
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.75,
      },
      {
        id: "cacheWrite1h",
        meter: "cacheWrite1h",
        unit: "1M tokens",
        currency: "USD",
        amount: 4.4,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 11 },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
      {
        id: "tool:web_fetch",
        meter: "tool:web_fetch",
        unit: "1k uses",
        currency: "USD",
        amount: 0,
      },
    ],
  },
  {
    id: "anthropic:claude-sonnet-5-5:us:fast",
    billedBy: "anthropic",
    model: "claude-sonnet-5-5",
    endpoint: "us",
    tier: "fast",
    promptTokensCount: "allInput",
    maxOutputTokens: 64_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 4.4,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.44,
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 5.5,
      },
      {
        id: "cacheWrite1h",
        meter: "cacheWrite1h",
        unit: "1M tokens",
        currency: "USD",
        amount: 8.8,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 22 },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
      {
        id: "tool:web_fetch",
        meter: "tool:web_fetch",
        unit: "1k uses",
        currency: "USD",
        amount: 0,
      },
    ],
  },
  {
    id: "anthropic:claude-haiku-4-5:global:standard",
    billedBy: "anthropic",
    model: "claude-haiku-4-5",
    endpoint: "global",
    tier: "standard",
    promptTokensCount: "allInput",
    maxOutputTokens: 64_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 1,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.1,
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.25,
      },
      { id: "cacheWrite1h", meter: "cacheWrite1h", unit: "1M tokens", currency: "USD", amount: 2 },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 5 },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
      {
        id: "tool:web_fetch",
        meter: "tool:web_fetch",
        unit: "1k uses",
        currency: "USD",
        amount: 0,
      },
    ],
  },
  {
    id: "anthropic:claude-haiku-4-5:global:fast",
    billedBy: "anthropic",
    model: "claude-haiku-4-5",
    endpoint: "global",
    tier: "fast",
    promptTokensCount: "allInput",
    maxOutputTokens: 64_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 2,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.2,
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.5,
      },
      { id: "cacheWrite1h", meter: "cacheWrite1h", unit: "1M tokens", currency: "USD", amount: 4 },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 10 },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
      {
        id: "tool:web_fetch",
        meter: "tool:web_fetch",
        unit: "1k uses",
        currency: "USD",
        amount: 0,
      },
    ],
  },
  {
    id: "anthropic:claude-haiku-4-5:us:standard",
    billedBy: "anthropic",
    model: "claude-haiku-4-5",
    endpoint: "us",
    tier: "standard",
    promptTokensCount: "allInput",
    maxOutputTokens: 64_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.1,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.11,
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.375,
      },
      {
        id: "cacheWrite1h",
        meter: "cacheWrite1h",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.2,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 5.5 },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
      {
        id: "tool:web_fetch",
        meter: "tool:web_fetch",
        unit: "1k uses",
        currency: "USD",
        amount: 0,
      },
    ],
  },
  {
    id: "anthropic:claude-haiku-4-5:us:fast",
    billedBy: "anthropic",
    model: "claude-haiku-4-5",
    endpoint: "us",
    tier: "fast",
    promptTokensCount: "allInput",
    maxOutputTokens: 64_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.2,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.22,
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.75,
      },
      {
        id: "cacheWrite1h",
        meter: "cacheWrite1h",
        unit: "1M tokens",
        currency: "USD",
        amount: 4.4,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 11 },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
      {
        id: "tool:web_fetch",
        meter: "tool:web_fetch",
        unit: "1k uses",
        currency: "USD",
        amount: 0,
      },
    ],
  },
];
